import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Andreas Herweg",
  title: "Head of Research at HEAD acoustics",
  description: `Dr. Andreas Herweg obtained his PhD (dr. rer. nat) in Neuroscience from the Graduate School of Life Science at the University of Würzburg. During his PhD he worked on decoding neural responses to auditory and tactile stimuli using EEG measurements. Since 2016 he works for the HEAD acoustics GmbH with a focus on jury testing and sound perception. Currently he is leading the “Sound Perception and Assessment” group working in different areas related to the perception of sound (sound design, jury testing, product sound quality, audio quality; etc.).


  <ul>
    <li><a href="https://www.head-acoustics.com/" target="_blank">https://www.head-acoustics.com/</a></li>
    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/02/authors/andreas-herweg.jpg",
};

export default author;
